import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateLanguageService } from '../../services/index';
import { AppConstants } from '../../constant/app.constants';
@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    providers: [TranslateLanguageService]
})
export class AppHeaderComponent {
    user_profile;
    user_profile_link;
    IMAGE_URL;
    translate_language = { 'lang': '' };
    all_translate_languages = [
        { 'name': 'LANGUAGE.EN', 'value': 'en' },
        { 'name': 'LANGUAGE.IT', 'value': 'it' },
        { 'name': 'LANGUAGE.FR', 'value': 'fr' },
    ];
    constructor(
        public _router: Router,
        public translate: TranslateService,
        public translateLanguageService: TranslateLanguageService
    ) {
     
        let AuthUser = JSON.parse(localStorage.getItem('currentUser'));
        this.IMAGE_URL = AppConstants.IMAGE_URL;
        if (AuthUser) {
            this.user_profile = AuthUser;
            if (this.user_profile.roles[0].id == 3) {
                this.user_profile_link = '/installers/edit/' + this.user_profile.id;
            }
            else if (this.user_profile.roles[0].id == 4) {
                this.user_profile_link = '/distributors/edit/' + this.user_profile.id;
            }
            else if (this.user_profile.roles[0].id == 5) {
                this.user_profile_link = '/clients/edit/' + this.user_profile.id;
            } else {
                this.user_profile_link = '/users/edit/' + this.user_profile.id;
            }
        }
        // translate.addLangs(['en', 'fr']);
        // const browserLang = translate.getBrowserLang();
        // translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
        if (!localStorage.getItem('language')) {
            translate.setDefaultLang('en');
            localStorage.setItem('language', 'en');
            this.translate_language.lang = 'en';
            this.translateLanguageService.getLanguage('en');
        } else {
            this.translate_language.lang = localStorage.getItem('language');
            this.translateLanguageService.getLanguage(this.translate_language.lang);
        }
    }

    changetranslate(language) {
        localStorage.setItem('language', language);
        this.translateLanguageService.getLanguage(language);
    }

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
        localStorage.removeItem('permissions');
        this._router.navigate(['/login']);
    }

}



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-header/app-header.component.ts